
import { BrowserRouter } from "react-router-dom";
import { QueryClientProvider } from "@tanstack/react-query";
import { ThemeProvider } from "@/components/theme/ThemeProvider";
import { AppRoutes } from "./routes/AppRoutes";
import { TooltipProvider } from "@/components/ui/tooltip";
import { DialogProvider } from "@/components/ui/dialog-provider";
import { createCustomQueryClient } from "@/hooks/use-query-client";
import { AnalyticsProvider } from "@/components/analytics/AnalyticsProvider";
import { Toaster } from "./components/ui/sonner";
import { InstallAppPrompt } from "./components/mobile/InstallAppPrompt";
import { useEffect } from "react";

// Create a client
const queryClient = createCustomQueryClient();

// App version - must match the version in the database
const APP_VERSION = "1.0.0";

function App() {
  console.log("App rendering");
  
  // Register service worker
  useEffect(() => {
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.register('/service-worker.js')
        .then(registration => {
          console.log('Service Worker registered with scope:', registration.scope);
        })
        .catch(error => {
          console.error('Service Worker registration failed:', error);
        });
        
      // Check if a service worker update is available
      navigator.serviceWorker.addEventListener('controllerchange', () => {
        console.log('Service Worker updated - reloading page for new version');
        window.location.reload();
      });
    }
  }, []);
  
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <ThemeProvider defaultTheme="light" storageKey="vite-ui-theme">
          <TooltipProvider>
            <DialogProvider>
              <AnalyticsProvider>
                <AppRoutes />
                <InstallAppPrompt />
                <Toaster />
              </AnalyticsProvider>
            </DialogProvider>
          </TooltipProvider>
        </ThemeProvider>
      </BrowserRouter>
    </QueryClientProvider>
  );
}

export default App;
